module.exports = __webpack_public_path__ + "static/media/trimex_guadalupana.4de84cda.png";